import { endpoint } from "../../../views/pages/manage/common/constant"
import { templateUrl } from "../../../views/pages/manage/common/constant/endpoints/documentService";
import { dropdownMapping, fetchAllPostPromisedData, fetchAllPromisedData, updateRequest } from "../../../views/pages/manage/common/utils/methods/commonMethods/utilityMethod"
import { downLoadFile } from "../../../views/pages/manage/masters/studentFinancials/paymentCollection/bulkCollection/utils";
import { transferTypes } from "../transferSetup/transferApprovalConfig/addEditCofigDialog/utils";
import { bulkTransferStatusDropdown, tranferPolicyDropdown } from "./constants";

export const fetchBulkTransferProcessTags = async () => {
    const allActiveProcessTags = await dropdownMapping(
        endpoint.process_Tag.getAllActive,
        "tagTypeDispValue",
        "tagTypeDesc",
        "tagTypeKey",
        "id"
    );

    const bulkTransferProcessTags = allActiveProcessTags?.filter(processTag => processTag.tagTypeKey?.startsWith("BULK_TRANSFER"));
    return bulkTransferProcessTags;

    // return fetchAllPromisedData(endpoint.process_Tag.getAllActive);
}

export const downloadTemplate = async serviceName => {
    const resp = await fetchAllPromisedData(`${templateUrl}?documentTypeDisplayValue=${serviceName}&serviceType=${serviceName}`);
    downLoadFile(resp?.["Template Url"]);

}

export const saveFileData = (file, transferType) => {

    const req = {
        processId: file?.transferFile?.processId,
        status: "ACTIVE",
        extId: file?.transferFile?.processId,
        documentType: file?.transferFile?.docType,
        signedUrl: "",
        isProcess: true,
        serviceName: transferType.value,
        processTagTypeId: transferType.id,
        fileName: file?.transferFile?.fileName,
        supportingDocKey : file?.supportingFile?.s3Key,
    }

    return fetchAllPostPromisedData(endpoint.fetchS3Url.commonUploadDms, req);
}

export const fetchBulkTransferRequests = ({filters, pageSize, offset}) => {
   const req = updateRequest({...filters, pageSize, offset});
   return fetchAllPostPromisedData(endpoint.studentTransfer.getBulkTransferRequests, req);
}

export const getSubmissionStatusExcelDetails = processId => {
    return fetchAllPromisedData(`${endpoint.studentTransfer.getBulkTransferSubmissionStatusDetails}/${processId}/rows`);
}

export const getFilterFormFields = () => {

        return [
            {
                label: 'Transfer Type',
                type: 'select',
                items: transferTypes,
                formKey: 'transferTypes',
                onChange: () => { },
                loading: false,
                isMulti: true,
                placeholder: "Select Tranfer Type",
                disbabled: false,
                isShowCount: true
            },
            {
                label: 'Status',
                type: 'select',
                items: bulkTransferStatusDropdown,
                formKey: 'statuses',
                onChange: () => { },
                loading: false,
                isMulti: true,
                placeholder: "Select Status",
                disbabled: false,
                isShowCount: true
            },
            {
                label: 'Transfer Policy',
                type: 'select',
                items: tranferPolicyDropdown,
                formKey: 'transferPolicy',
                onChange: () => { },
                loading: false,
                isMulti: false,
                placeholder: "Select Tranfer Policy",
                disbabled: false,
            },

            {
                label: 'Uploaded By',
                type: 'text',
                formKey: 'uploadedBy',
                onChange: () => { },
                placeholder: "Enter",
                disbabled: false,
            },

            {
                label: 'Process Date',
                type: 'date',
                formKey: 'processDate',
                onChange: () => { },
                placeholder: "Select date",
                disabled: false,
                minDate: '',
                maxDate: '',
            },
        ]

}

